@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}
<div class="container">
    <div class="single-column-layout">
        <h1>Licensed Client Documents</h1>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Instance</th>
                    <th>Company</th>
                    <th>Status</th>
                    <th>Assignments</th>
                </tr>
            </thead>
            <tbody>
                @for (client of licensedClients; track client) {
                    <tr>
                        <td>
                            {{ client.instanceName }}
                        </td>
                        <td>
                            {{ client.topLevelCompanyName }}
                        </td>
                        <td>
                            {{ getStatus(client) }}
                        </td>
                        <td>
                            @if (!client.cancellationDate) {
                                <button (click)="configure(client)" class="ace-btn btn-sm ace-btn btn-primary">
                                    Configure
                                </button>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
